import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {PersonDelegation} from '../person/person-delegation';
import {GoogleService} from './google-service';

@Service()
export class TaskDelegationService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public save(delegation: PersonDelegation): Observable<string> {
    let url = this.urlBase + 'delegations/save';
    let body = JSON.stringify(delegation);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  public adminSave(delegation: PersonDelegation): Observable<string> {
    const url = this.urlBase + 'delegations/adminSave';
    return this.http.post(url, JSON.stringify(delegation), {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public getUserDelegations(): Observable<PersonDelegation[]> {
    let url = this.urlBase + 'delegations/user';
    return this.http.get<PersonDelegation[]>(url, {headers: this.getRequestHeaders()});
  }

  public getPersonDelegations(personId: string): Observable<PersonDelegation[]> {
    const url = this.urlBase + 'delegations/person/' + personId;
    return this.http.get<PersonDelegation[]>(url, {headers: this.getRequestHeaders()});
  }

}
